/* Crush landing (redesign) — Shopify glue. Loaded after site.js (both deferred).
   1. Checkout: the three plan buttons ([data-plan]) go straight to checkout.
      Lifetime = cart permalink straight to checkout (no cart calls), like the live Crush page.
      Monthly/Annual = drop any other membership from the cart, add hardware + membership with
      its selling plan via /cart/add.js, then go to checkout. Other cart items are kept.
   2. Video primer: start buffering a clip the moment the shopper shows intent (hover, touch,
      focus) so the dialog's video plays immediately on click.
   3. Reviews: if the Judge.me widget hasn't rendered after a few seconds, show the bundled snapshot.
   4. Anchor offset: keep #plans etc. clear of the theme's sticky header.
   5. Clarity: tag the session (page, offer, bonus, utm) and send events (plans seen, plan click, video,
      reviews, FAQ, checkout error) so recordings of this page can be filtered in Microsoft Clarity. */
(function () {
  "use strict";
  var plans = window.HUH_PLANS || {};
  var cfg = window.HUH_CHECKOUT || {};
  var root = document.getElementById("crush-ld");
  if (!root) return;

  /* ---------------------------------------------------------------- checkout */
  function jpost(url, body) {
    return fetch(url, { method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: body ? JSON.stringify(body) : undefined });
  }
  function finish(destination) {
    if (window.huhSeasonOffer && typeof window.huhSeasonOffer.checkoutUrl === "function") {
      destination = window.huhSeasonOffer.checkoutUrl(destination);
      return window.huhSeasonOffer.apply().catch(function () {}).then(function () { window.location.assign(destination); });
    }
    window.location.assign(destination);
  }
  function setBusy(btn, on) {
    if (!btn) return;
    if (on) { btn._label = btn.textContent; btn.textContent = "Taking you to checkout…"; btn.disabled = true; btn.setAttribute("aria-busy", "true"); }
    else { if (btn._label) btn.textContent = btn._label; btn.disabled = false; btn.removeAttribute("aria-busy"); }
  }
  function showError(msg, btn) {
    var el = btn && btn.parentNode ? btn.parentNode.querySelector(".plan-error") : null;
    if (!el && btn && btn.parentNode) {
      el = document.createElement("p"); el.className = "plan-error"; el.setAttribute("role", "alert");
      btn.insertAdjacentElement("afterend", el);
    }
    if (!el) return;
    el.textContent = msg || "Something went wrong. Please try again.";
    el.hidden = false;
  }
  var buying = false;
  var busyButtons = [];
  // Back button from checkout restores this page from the back-forward cache with the button still
  // "Taking you to checkout…" and disabled; reset so another plan can be chosen.
  function resetBuying() {
    buying = false;
    busyButtons.forEach(function (b) { setBusy(b, false); });
    busyButtons = [];
  }
  window.addEventListener("pageshow", function (e) { if (e.persisted) resetBuying(); });
  window.addEventListener("pagehide", resetBuying);
  document.addEventListener("visibilitychange", function () { if (document.visibilityState === "visible") resetBuying(); });
  function buy(key, btn) {
    var plan = plans[key];
    if (!plan || buying) return;
    buying = true;
    setBusy(btn, true);
    busyButtons.push(btn);
    var err = btn && btn.parentNode ? btn.parentNode.querySelector(".plan-error") : null; if (err) err.hidden = true;
    if (plan.permalink && !plan.items) {
      if (plan.offerCode) {
        // Our own offer code replaces whatever the theme pre-applied (the season code), so checkout shows the
        // price on the card. Permalink → checkout, no cart reads.
        jpost("/cart/update.js", { discount: plan.offerCode }).catch(function () {})
          .then(function () { window.location.assign(plan.permalink); });
        return;
      }
      finish(plan.permalink); return;
    }
    var remove = (cfg.membershipVariants || []).slice();
    fetch("/cart.js", { headers: { "Accept": "application/json" } })
      .then(function (r) { return r.ok ? r.json() : { items: [] }; })
      .then(function (cart) {
        var updates = {};
        (cart.items || []).forEach(function (it) {
          if (remove.indexOf(it.variant_id) !== -1) updates[it.key] = 0;
        });
        if (Object.keys(updates).length) return jpost("/cart/update.js", { updates: updates });
      })
      .then(function () { return jpost("/cart/add.js", { items: plan.items }); })
      .then(function (res) {
        if (!res.ok) {
          return res.json().catch(function () { return {}; }).then(function (d) {
            throw new Error(d.description || d.message || ("HTTP " + res.status));
          });
        }
        return finish(cfg.checkout || "/checkout");
      })
      .catch(function (e) {
        resetBuying();
        clarity("event", "checkout_error");
        showError(e && e.message ? e.message : "", btn);
      });
  }
  // Capture phase + preventDefault: site.js (bubble phase on document) then ignores the click, so no dialog opens.
  root.addEventListener("click", function (e) {
    var b = e.target.closest ? e.target.closest("[data-plan],[data-checkout-plan]") : null;
    if (!b || !root.contains(b)) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button > 0) return;
    e.preventDefault();
    buy(b.getAttribute("data-plan") || b.getAttribute("data-checkout-plan"), b);
  }, true);

  /* ---------------------------------------------------------------- Clarity tags + events */
  // The theme's Clarity tag defines window.clarity (a queue until clarity.js loads), so calls are safe at any time.
  function clarity() {
    if (typeof window.clarity !== "function") return;
    try { window.clarity.apply(null, arguments); } catch (e) {}
  }
  function clarityTag(key, value) { if (value) clarity("set", key, String(value)); }
  clarityTag("page", "crush-landing");
  clarityTag("offer", (plans.lifetime && plans.lifetime.offerCode) || "none");
  clarityTag("bonus", root.querySelector(".plan-bonus") ? "wraparound" : "none");
  var stock = root.querySelector(".plan-bonus em");
  var stockN = stock && /\d+/.exec(stock.textContent);
  clarityTag("bonus_stock", stockN ? stockN[0] : "");
  try {
    var q = new URLSearchParams(window.location.search);
    ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"].forEach(function (k) { clarityTag(k, q.get(k)); });
    if (q.get("fbclid")) clarityTag("ad_click", "meta");
    if (q.get("gclid")) clarityTag("ad_click", "google");
    if (q.get("ttclid")) clarityTag("ad_click", "tiktok");
  } catch (e) {}
  if ("IntersectionObserver" in window) {
    var plansEl = document.getElementById("plans");
    if (plansEl) {
      var seen = new IntersectionObserver(function (entries) {
        if (entries.some(function (en) { return en.isIntersecting; })) { clarity("event", "plans_view"); seen.disconnect(); }
      }, { threshold: 0.3 });
      seen.observe(plansEl);
    }
  }
  root.addEventListener("click", function (e) {
    var t = e.target.closest ? e.target : null;
    if (!t) return;
    var v = t.closest("[data-video]");
    if (v) { clarityTag("video", v.getAttribute("data-video")); clarity("event", "video_open"); return; }
    if (t.closest("[data-reviews]")) { clarity("event", "reviews_open"); return; }
    if (t.closest("details summary")) { clarity("event", "faq_open"); return; }
    if (t.closest("[data-plan],[data-checkout-plan]")) {
      var k = t.closest("[data-plan],[data-checkout-plan]");
      k = k.getAttribute("data-plan") || k.getAttribute("data-checkout-plan");
      clarityTag("plan", k); clarity("event", "plan_" + k + "_click"); clarity("upgrade", "plan_click");
    }
  }, true);

  /* ---------------------------------------------------------------- video primer */
  var media = window.HUH_MEDIA || {};
  var primer = null, primed = "";
  function prime(key) {
    var item = media[key];
    if (!item || !item.src || primed === item.src) return;
    var active = document.getElementById("active-video");
    if (active) active.preload = "auto";
    if (!primer) {
      primer = document.createElement("video");
      primer.muted = true; primer.playsInline = true; primer.preload = "auto";
      primer.setAttribute("aria-hidden", "true"); primer.tabIndex = -1;
      primer.style.cssText = "position:absolute;width:1px;height:1px;opacity:0;pointer-events:none;overflow:hidden";
      root.appendChild(primer);
    }
    primed = item.src;
    primer.src = item.src;
    primer.load();
  }
  ["pointerenter", "touchstart", "focusin"].forEach(function (type) {
    root.addEventListener(type, function (e) {
      var t = e.target.closest ? e.target.closest("[data-video]") : null;
      if (t) prime(t.getAttribute("data-video"));
    }, { passive: true, capture: true });
  });
  // Also warm the first (featured) clip once the page is idle, on connections that allow it.
  var conn = navigator.connection || {};
  if (!conn.saveData && (!conn.effectiveType || /4g/.test(conn.effectiveType))) {
    var first = root.querySelector("[data-video]");
    var idle = window.requestIdleCallback || function (f) { return setTimeout(f, 1500); };
    if (first) idle(function () { prime(first.getAttribute("data-video")); });
  }

  /* ---------------------------------------------------------------- reviews fallback */
  var live = document.getElementById("reviews-live");
  var snapshot = document.getElementById("reviews-content");
  var trigger = root.querySelector("[data-reviews]");
  function checkReviews() {
    if (!live || !snapshot) return;
    var widget = live.querySelector(".jdgm-review-widget");
    var rendered = widget && widget.children.length > 0;
    if (!rendered) { live.hidden = true; snapshot.hidden = false; }
  }
  if (trigger) trigger.addEventListener("click", function () { setTimeout(checkReviews, 400); setTimeout(checkReviews, 3000); });
  setTimeout(checkReviews, 6000);

  /* ---------------------------------------------------------------- sticky header offset */
  function headerOffset() {
    var h = document.querySelector(".site-header-sticky-wrapper, .custom-header-banner, .section-header, header.header");
    var px = h ? Math.round(h.getBoundingClientRect().height) : 0;
    document.documentElement.style.setProperty("--crush-ld-header", (px > 0 ? px + 12 : 22) + "px");
  }
  headerOffset();
  window.addEventListener("resize", headerOffset);
  window.addEventListener("load", headerOffset, { once: true });
})();
